import { Component, OnInit } from '@angular/core';
import { Globals } from '../../../globals';
import { SentEmail } from '../../../service/modal/sendEmai';
import { ActivatedRoute } from '@angular/router';
import { MailViewService } from '../../../service/apiservice/mailview.service';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-sendemail-view-mobile',
  templateUrl: './sendemail-view-mobile.component.html',
  styleUrls: ['./sendemail-view-mobile.component.css']
})
export class SendemailViewMobileComponent implements OnInit {
  mailId: number;
  ViewData: SentEmail = new SentEmail();
  todayDate: any;

  constructor(private global:Globals,private route: ActivatedRoute, private _mailService: MailViewService) { }

  ngOnInit() {
    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.mailId = params['id']);
   
    this.todayDate = new Date();
    this.getGetCurrentMail();
  }
  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }
getGetCurrentMail(){
  this._mailService.GetCurrentSendMail(this.mailId)
  .subscribe((response) => {
    Object.assign(this.ViewData, response);
  }, error => {
     info_noti(error);
  })
}
}
